import api from '../../axios';
import { RsValue } from '../../../models/base/BaseModel';
import {
  RsRole,
  RsPermission,
  RsRoleClaim,
  RsUserRoleItem,
} from '../../../models/user-management/RolePermissionModels';

export interface PmRoleCreate {
  name: string;
  isActive: boolean;
}
export interface PmRoleUpdate {
  name?: string;
  isActive?: boolean;
}
export interface PmRoleClaimCreate {
  roleId: string;
  claimType: string;
  claimValue: string;
  isActive: boolean;
}
export interface PmRoleClaimUpdate {
  claimType?: string;
  claimValue?: string;
  isActive?: boolean;
}
export interface PmUserRoleAssign {
  userId: string;
  roleId: string;
}

export const rolePermissionService = {
  getRoles: (): Promise<RsRole[]> => api.get('api/RolePermission/roles'),
  getPermissions: (): Promise<RsPermission[]> => api.get('api/RolePermission/permissions'),
  getRoleClaims: (): Promise<RsRoleClaim[]> => api.get('api/RolePermission/role-claims'),
  getUserRoles: (): Promise<RsUserRoleItem[]> => api.get('api/RolePermission/user-roles'),

  createRole: (data: PmRoleCreate): Promise<RsValue<RsRole>> =>
    api.post('api/RolePermission/roles', data),
  updateRole: (id: string, data: PmRoleUpdate): Promise<RsValue<boolean>> =>
    api.put(`api/RolePermission/roles/${id}`, data),
  deleteRole: (id: string): Promise<RsValue<boolean>> =>
    api.delete(`api/RolePermission/roles/${id}`),

  createRoleClaim: (data: PmRoleClaimCreate): Promise<RsValue<number>> =>
    api.post('api/RolePermission/role-claims', data),
  updateRoleClaim: (id: number, data: PmRoleClaimUpdate): Promise<RsValue<boolean>> =>
    api.put(`api/RolePermission/role-claims/${id}`, data),
  deleteRoleClaim: (id: number): Promise<RsValue<boolean>> =>
    api.delete(`api/RolePermission/role-claims/${id}`),

  assignUserRole: (data: PmUserRoleAssign): Promise<RsValue<boolean>> =>
    api.post('api/RolePermission/user-roles/assign', data),
  removeUserRole: (data: PmUserRoleAssign): Promise<RsValue<boolean>> =>
    api.post('api/RolePermission/user-roles/remove', data),
};
